import Vue from 'vue';
import Vuex from 'vuex';

import api from '@/bingMaps';

import { round } from '@/helpers';
import states from '@/data/states.json';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: true,
    setLocationOpen: false,
    location: {},
    watchId: null,
    colorScheme: localStorage.getItem('colorScheme') || 'auto',
    address: null,
    ezoicAds: {},
  },
  getters: {
    displayCoordinates(state) {
      if (!state.location) {
        return null;
      }
      return `${round(state.location.latitude, 5)}, ${round(state.location.longitude, 5)}`;
    },
  },
  actions: {
    getUserLocation({ dispatch }) {
      navigator.geolocation.getCurrentPosition(
        (location) => {
          dispatch('setUserLocation', location);
        },
        error => dispatch('locationError', error),
        {
          enableHighAccuracy: true,
          timeout: 30 * 1000,
        },
      );
    },
    watchUserLocation({ state, commit, dispatch }) {
      const watchId = navigator.geolocation.watchPosition(
        (location) => {
          // only update location if the watch is still active
          if (state.watchId) {
            dispatch('setUserLocation', location);
          }
        },
        error => dispatch('locationError', error),
        {
          enableHighAccuracy: true,
          timeout: 30 * 1000,
        },
      );
      commit('setItem', { item: 'watchId', value: watchId });
    },
    setUserLocation({ state, dispatch }, location) {
      const previousLocation = state.location;
      dispatch('updateLocation', {
        latitude: location.coords.latitude,
        longitude: location.coords.longitude,
        accuracy: location.coords.accuracy,
      });
      if (state.location.latitude !== previousLocation.latitude
        || state.location.longitude !== previousLocation.longitude) {
        dispatch('fetchAddress');
      }
    },
    locationError({ commit, dispatch }, error) {
      console.warn('location access denied', error);
      commit('setItem', { item: 'loading', value: false });
      dispatch('setLocationOpen', true);
    },
    stopWatchingUserLocation({ state, commit }) {
      navigator.geolocation.clearWatch(state.watchId);
      commit('setItem', { item: 'watchId', value: null });
    },
    fetchAddress({ state, dispatch }) {
      if (!navigator.onLine) {
        console.log('offline, not fetching address');
        return false;
      }
      let loaded = false;
      // delay showing the loading animation in case the response is super fast
      setTimeout(() => {
        if (!loaded) {
          dispatch('setLoading', true);
        }
      }, 200);
      return api.getLocation({
        latitude: round(state.location.latitude, 5),
        longitude: round(state.location.longitude, 5),
      }).then((address) => {
        loaded = true;
        const newAddress = address;
        // set state to full state name if its a US state
        if (address.adminDistrict && address.adminDistrict.length === 2 && address.adminDistrict in states) {
          newAddress.adminDistrict = states[address.adminDistrict];
        }
        dispatch('setAddress', newAddress);
        dispatch('setLoading', false);
      }).catch((error) => {
        console.warn(error);
      });
    },
    updateLocation({ commit }, {
      latitude, longitude, accuracy = 100, title = null,
    }) {
      commit('setItem', {
        item: 'location',
        value: {
          latitude, longitude, accuracy, title,
        },
      });
    },
    setLocationOpen({ commit }, isOpen) {
      commit('setItem', { item: 'setLocationOpen', value: isOpen });
    },
    setLoading({ commit }, isLoading) {
      commit('setItem', { item: 'loading', value: isLoading });
    },
    setAddress({ commit }, address) {
      commit('setItem', { item: 'address', value: address });
    },
    setColorScheme({ commit }, colorScheme) {
      localStorage.setItem('colorScheme', colorScheme);
      commit('setItem', { item: 'colorScheme', value: colorScheme });
    },
    setAd({ commit }, { id, html }) {
      commit('setAd', { id, html });
    },
  },
  mutations: {
    setItem(state, { item, value }) {
      Vue.set(state, item, value);
    },
    setAd(state, { id, html }) {
      Vue.set(state.ezoicAds, id, html);
    },
  },
});
